import "../css/index.scss";

import { components } from "./components";
import {initializeComponents} from "./componentFactory";
import {setupSentrySpotlight} from "@/sentry";

initializeComponents(components);

// Spotlight is a dev-only tool — skip it when accessing from a non-localhost device
// (e.g. phone on LAN). setupSentrySpotlight() already checks NODE_ENV internally.
if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    setupSentrySpotlight();
}
